const integerParse = (value, prefix = '', isAbsolute) => {
  let stringValue = new String(value) // eslint-disable-line

  stringValue = stringValue
    .replace(/-/g, '')
    .replace(/,/g, '.')
    .replace(prefix, '')

  const splitedValues = stringValue.split('.')

  return splitedValues[0]
}

export default integerParse



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/integerParse.js